import React from "react";
import {
  Input,
  Stack,
  Button,
  Center,
  Heading,
  useToast,
  FormControl,
  FormErrorMessage,
  Link as ChakraLink,
  Text,
} from "@chakra-ui/react";
import { useTranslation } from "react-i18next";
import { requestPasswordReset } from "../../services/authService";
import { useMutation } from "@tanstack/react-query";
import { Link as RouterLink } from "react-router-dom";
import { Formik, Form, Field } from "formik";
import * as Yup from "yup";

function ForgotPassword() {
  const { t } = useTranslation("common");
  const toast = useToast();

  const mutation = useMutation({
    mutationFn: (email) => requestPasswordReset(email),
    onSuccess: () => {
      toast({
        title: t("forgotPasswordSuccessMessage"),
        status: "success",
      });
    },
    onError: () => {
      toast({
        title: t("forgotPasswordSuccessMessage"),
        status: "success",
      });
    },
  });

  return (
    <Center>
      <Stack spacing={3} width={"400px"}>
        <Heading size={"lg"} mb={4}>
          {t("forgotPasswordHeading")}
        </Heading>
        <Text fontSize="sm" color="gray.600">
          {t("forgotPasswordDescription")}
        </Text>
        <Formik
          initialValues={{ email: "" }}
          validationSchema={Yup.object({
            email: Yup.string()
              .email(t("invalidEmailMessage"))
              .required(t("requiredFieldMessage")),
          })}
          onSubmit={(values) => {
            mutation.mutate(values.email);
          }}
        >
          {(props) => (
            <Form>
              <Stack spacing={3}>
                <Field name="email">
                  {({ field, form }) => (
                    <FormControl
                      isInvalid={form.errors.email && form.touched.email}
                    >
                      <Input
                        {...field}
                        placeholder={t("emailInputPlaceholder")}
                        variant="filled"
                      />
                      <FormErrorMessage>{form.errors.email}</FormErrorMessage>
                    </FormControl>
                  )}
                </Field>
                <Button
                  width="full"
                  isLoading={mutation.isLoading}
                  type="submit"
                  colorScheme="whatsapp"
                  mt={4}
                >
                  {t("sendResetLinkButtonText")}
                </Button>
                <ChakraLink as={RouterLink} to="/login" color="teal.600">
                  {t("backToLoginLinkText")}
                </ChakraLink>
              </Stack>
            </Form>
          )}
        </Formik>
      </Stack>
    </Center>
  );
}

export default ForgotPassword;
